import React from 'react';
import type { PartnerUser } from '../../hooks/requests/queries/use_all_users_query';

interface VoiceStatsGridProps {
  totalUsers: number;
  selectedUser: PartnerUser | null;
  messageCount: number;
}

const VoiceStatsGrid: React.FC<VoiceStatsGridProps> = ({
  totalUsers,
  selectedUser,
  messageCount,
}) => {
  const stats = [
    {
      label: 'Available Users',
      value: totalUsers.toLocaleString(),
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      iconBgClass: 'bg-au-primary-lightest',
      iconColorClass: 'text-au-primary',
    },
    {
      label: 'Selected User',
      value: selectedUser?.first_name || '—',
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      ),
      iconBgClass: 'bg-au-success-lightest',
      iconColorClass: 'text-au-success',
    },
    {
      label: 'Messages',
      value: messageCount.toLocaleString(),
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z" />
        </svg>
      ),
      iconBgClass: 'bg-au-secondary-lightest',
      iconColorClass: 'text-au-secondary',
    },
  ];

  return (
    <div className="flex gap-4">
      {stats.map((stat, index) => (
        <div key={index} className="au-stat-card flex-1">
          <div className="flex items-center justify-between mb-3">
            <div
              className={`flex items-center justify-center w-10 h-10 rounded-au-lg ${stat.iconBgClass}`}
            >
              <span className={stat.iconColorClass}>{stat.icon}</span>
            </div>
          </div>
          <div className="au-stat-card-label">{stat.label}</div>
          <div className="au-stat-card-value">{stat.value}</div>
        </div>
      ))}
    </div>
  );
};

export default VoiceStatsGrid;
